import React from 'react';
import { CheckIcon, AlertTriangleIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { MOCKUP_URL, heroChecks } from '../../data/offer';
export function Hero() {
  return <header className="relative bg-ink" data-id="element-207" data-mp="cvl79czvvsx9">
      <div className="bg-volt px-4 py-2.5 text-center font-display text-[15px] font-bold uppercase tracking-wide text-ink sm:text-base" data-id="element-208" data-mp="cujhs3i4f3w0">
        The Professional HVAC Electrical Diagnostic System
      </div>

      <div className="mx-auto grid max-w-6xl items-center gap-8 px-5 pb-16 pt-8 sm:pt-12 lg:grid-cols-[1.05fr_1fr] lg:gap-12 lg:pb-24" data-id="element-209" data-mp="mry0k9rio4rh">
        <div data-id="element-210" data-mp="vlu7ihc41amb">
          <p className="font-display text-lg font-bold uppercase tracking-[0.06em] text-volt sm:text-xl" data-id="element-211" data-mp="vm2l6bg24jyk">
            HVAC Electrical Troubleshooting Blueprint™
          </p>
          <h1 className="mt-3 text-balance font-display text-[44px] font-extrabold uppercase leading-[0.92] text-white sm:text-6xl lg:text-[68px]" data-id="element-212" data-mp="15ks3g5bv86fc">
            Organize your next HVAC electrical fault into a{' '}
            <span className="text-amber" data-id="element-213" data-mp="9oc9orfa21kb">5-step troubleshooting plan</span>
          </h1>
          <p className="mt-4 text-pretty text-lg font-semibold text-white sm:text-xl" data-id="element-214" data-mp="4ozo0a0570jb">
            With clear test checkpoints, decision trees & documentation.
          </p>

          <img src={MOCKUP_URL} alt="HVAC Electrical Troubleshooting Blueprint: 6 volumes and 5 bonus resources" className="mx-auto mt-6 w-full max-w-[520px] lg:hidden" data-id="element-215" data-mp="3vwu7a2adcmf2" />

          <p className="mt-6 text-pretty text-[17px] leading-relaxed text-mist" data-id="element-216" data-mp="nfhb9z27h3xa">
            <strong className="text-white" data-id="element-217" data-mp="nhk0whzg4v1h">Stop jumping between electrical components without a clear diagnostic direction.</strong>{' '}
            Turn scattered troubleshooting observations into a structured electrical fault investigation using the{' '}
            <strong className="text-volt" data-id="element-218" data-mp="1b5lcjzrx8rl4">HVAC ELECTRICAL FAULT PATHWAY™</strong>.
          </p>

          <div className="mt-7 rounded-2xl border border-line bg-panel p-5" data-id="element-219" data-mp="16da1q1vn7lds">
            <div className="flex items-end justify-between gap-4" data-id="element-220" data-mp="30lnn8la5g1qh">
              <div data-id="element-221" data-mp="30o9wqqglorbc">
                <p className="text-sm font-semibold uppercase tracking-wide text-mist" data-id="element-222" data-mp="35ljrmlmrdv6k">Complete blueprint</p>
                <p className="font-display text-xl font-bold uppercase leading-tight text-white" data-id="element-223" data-mp="2qwvzyqg1a5lw">
                  6 Volumes + 5 Bonuses
                </p>
              </div>
              <p className="font-display text-6xl font-extrabold leading-none text-amber" data-id="element-224" data-mp="2hvfsaqglshld">$27</p>
            </div>
            <div className="mt-5" data-id="element-225" data-mp="2mv23kucvfnrj">
              <CtaButton id="first-cta" label="Build my HVAC troubleshooting workflow" data-id="element-226" data-mp="2mw3pxuzc7wok" />
            </div>
            <ul className="mt-5 grid gap-2 sm:grid-cols-2" data-id="element-227" data-mp="27yt883w3puke">
              {heroChecks.map(item => <li key={item} className="flex items-start gap-2 text-[15px] text-white" data-id="element-228" data-mp="2cwl6rgr94exk">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ok" strokeWidth={3} aria-hidden="true" data-id="element-229" data-mp="66ep51htmk2e" />
                  {item}
                </li>)}
            </ul>
          </div>

          <p className="mt-5 flex items-start gap-2 text-xs leading-relaxed text-mist/80" data-id="element-230" data-mp="1vna9owub0zu4">
            <AlertTriangleIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-amber" aria-hidden="true" data-id="element-231" data-mp="1qpiik51hhhqz" />
            Designed for qualified HVAC technicians and service professionals. Electrical testing must follow applicable
            safety standards, equipment manufacturer instructions, and workplace procedures.
          </p>
        </div>

        <div className="hidden lg:block" data-id="element-232" data-mp="2abwwtkq6avvw">
          <img src={MOCKUP_URL} alt="HVAC Electrical Troubleshooting Blueprint: 6 volumes and 5 bonus resources" className="w-full" data-id="element-233" data-mp="2ab52ed8bb477" />
          <p className="mt-4 text-center font-display text-2xl font-bold uppercase text-white" data-id="element-234" data-mp="2jcbm0v69cv4o">
            One system. Five diagnostic stages. <span className="text-volt" data-id="element-235" data-mp="ty6rkanbi1ko">A documented workflow.</span>
          </p>
        </div>
      </div>
    </header>;
}